import React from "react";
import { PageBlock } from "../../../types/notebook/note/block/page";
import { NoteBlockContainer } from "../../note";
import { PageLink } from "../pageLink";

export const NotePageBlockComponent: React.FC<{ block: PageBlock; blockIndex: number }> = React.memo(({ block }) => {
  const { "sub-page-id": subPageId } = block;

  return (
    <NoteBlockContainer name="Page">
      <PageLink pageId={subPageId} data-testid={`block-page-link-${subPageId}`} />
    </NoteBlockContainer>
  );
});
